module.exports = __webpack_public_path__ + "img/28n.6c3d92fb.png";